import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { map } from 'rxjs/operators'

export interface Entry {
    key: string
    description: string
    rank: number
    disabled: boolean
    readOnly?: boolean

    id?: string // client only
}

export interface Type {
    name: string
    title: string
    hidden?: boolean
}

@Injectable()
export class HandbookService {
    constructor(private http: HttpService) {}

    public getEntries(type: Type): Observable<Entry[]> {
        return this.http.get('/handbook').pipe(
            map(orgTypes => {
                return Object.assign({}, ...Object.values(orgTypes))[type.name].map(x => ({
                    ...x,
                    key: x.value,
                    description: x.title
                }))
            })
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getTypes(): Observable<any> {
        return this.http.get('/handbook').pipe(
            map(orgTypes =>
                this.distinct([].concat(...Object.values(orgTypes).map(Object.keys))).map(x => ({
                    name: x,
                    title: this.splitCamelCase(this.ucfirst(x))
                }))
            )
        )
    }

    private distinct(xs: string[]): string[] {
        return Object.keys(xs.reduce((acc, x) => Object.assign(acc, { [x]: x }), {}))
    }

    private ucfirst(x: string): string {
        return x.charAt(0).toUpperCase() + x.slice(1)
    }

    private splitCamelCase(x: string): string {
        return x.replace(/([a-z])([A-Z])/g, '$1 $2')
    }
}
